import { createAsyncThunk } from "@reduxjs/toolkit";

const GetQrLink = createAsyncThunk(
  "getQrLink",
  async (func, { rejectWithValue }) => {
    try {
      const response = await func();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

export default GetQrLink;
